<!-- @/components/strapi_components/blocks/RichText.vue -->
<script lang="ts" setup>

defineProps({
  source: {
    type: String,
    required: true,
  },
});
</script>

<template>
    <div
      v-html="$mdRenderer.render(source)">
  </div>
</template>    